import { SEO_SITE_URL } from '../config/seoConfig';

export const toAbsoluteUrl = (pathOrUrl) => {
  if (!pathOrUrl) return SEO_SITE_URL;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const normalized = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${SEO_SITE_URL}${normalized}`;
};

export const stripHtml = (value = '') =>
  value.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();

export const truncateText = (value = '', maxLength = 160) => {
  if (value.length <= maxLength) return value;
  return `${value.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
};
